import styled from "styled-components";

export const AddToCartBtnWrapper = styled.div`
    @supports (-webkit-touch-callout: none) {
        button {
            margin-left: 1px !important;
        }
    }
`